import React from "react";

/**
 * Renders ticket reason checkboxes — grouped by category, flat list, or loading spinner.
 *
 * Props:
 * - hasCategories: boolean
 * - ticketReasonsGrouped: Record<string, string[]>
 * - ticketReasons: string[]
 * - ticketReasonsLoading: boolean
 * - onCheckboxChange: (e) => void
 * - onOtherIssueChange: (e) => void
 * - reasonOther: string
 */
const TicketReasonsCheckboxes = ({
  hasCategories,
  ticketReasonsGrouped,
  ticketReasons,
  ticketReasonsLoading,
  onCheckboxChange,
  onOtherIssueChange,
  reasonOther,
}) => {
  if (ticketReasonsLoading) {
    return (
      <div className="d-flex justify-content-center py-4">
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }

  if (hasCategories) {
    return (
      <>
        {Object.entries(ticketReasonsGrouped).map(([category, issues]) => (
          <div key={category}>
            <h6 className="mt-3 mb-2">{category}</h6>
            {issues.map((item, index) => (
              <label
                className={`add-new-warranty-checkbox-container ${
                  item.length > 50
                    ? "add-new-warranty-checkbox-container-full-width"
                    : ""
                }`}
                key={`${category}-${index}`}
              >
                <input
                  type="checkbox"
                  id={`reason-${category}-${index}`}
                  name="reason"
                  value={item}
                  onChange={onCheckboxChange}
                />
                <span className="add-new-warranty-checkbox-text">{item}</span>
              </label>
            ))}
          </div>
        ))}
        <div className="form-field">
          <label>Other Issue (please describe below)</label>
          <input
            type="text"
            onChange={onOtherIssueChange}
            id="reason-other"
            name="reasonOther"
            value={reasonOther || ""}
          />
        </div>
      </>
    );
  }

  return ticketReasons.map((item, i) => (
    <label
      className={`add-new-warranty-checkbox-container ${
        item.length > 50
          ? "add-new-warranty-checkbox-container-full-width"
          : ""
      }`}
      key={i}
    >
      <input
        type="checkbox"
        id={"reason" + i}
        name="reason"
        value={item}
        onChange={onCheckboxChange}
      />
      <span className="add-new-warranty-checkbox-text">{item}</span>
    </label>
  ));
};

export default TicketReasonsCheckboxes;
